/**
 * @generated SignedSource<<9ec5eab5eafa4905df99b357ef50c78a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "FolderUnreadChangeSubscription",
    "kind": "LinkedField",
    "name": "folderUnreadChange",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "FolderUnreadChange",
        "kind": "LinkedField",
        "name": "folderUnreadChanges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "folderId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "change",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "reset",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "Folders_folderUnreadChangeSubscription",
    "selections": (v0/*: any*/),
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "Folders_folderUnreadChangeSubscription",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "f376d7ec497a7e68d3104b4e964bf56b",
    "id": null,
    "metadata": {},
    "name": "Folders_folderUnreadChangeSubscription",
    "operationKind": "subscription",
    "text": "subscription Folders_folderUnreadChangeSubscription {\n  folderUnreadChange {\n    folderUnreadChanges {\n      folderId\n      change\n    }\n    reset\n  }\n}\n"
  }
};
})();

node.hash = "2dc9db151b900f850dbee35d89515877";

module.exports = node;
